import { render, staticRenderFns } from "./product-image-gallery.vue?vue&type=template&id=071d745e&"
import script from "./product-image-gallery.vue?vue&type=script&lang=js&"
export * from "./product-image-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports